import { Component, inject } from '@angular/core';
import { AuthService, User } from '@isophi/core-legacy';
import { Child } from '@isophi/pap-api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';

import { RouterLinkFactory } from '../../../core/router/router-link.factory';
import { AccountService } from '../../../core/services/account.service';
import { ChildService } from '../../../core/services/child.service';
import { HelperService } from '../../../core/services/helper.service';
import { LicenseService } from '../../../core/services/license.service';
import { EditLicenseComponent } from '../../../modules/user/components/edit-license/edit-license.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
class HeaderComponent {
  private readonly location = inject(Location);
  licenses$: Observable<{ premium: boolean }>;

  selectedChild$: Observable<Child | null>;

  isDirector = this.authService.loggedUser?.teacher.isDirector;

  public constructor(
    private childService: ChildService,
    public routerLinkFactory: RouterLinkFactory,
    private modalService: NgbModal,
    private licenseService: LicenseService,
    private accountService: AccountService,
    private authService: AuthService,
    public helperService: HelperService,
    private router: Router
  ) {
    this.licenses$ = combineLatest({
      premium: this.licenseService.hasPremium(),
    });
    this.selectedChild$ = this.childService.getSelectedChild();
  }

  get username(): string {
    return (this.authService.loggedUser?.firstName ?? '') + ' ' + (this.authService.loggedUser?.lastName ?? '');
  }

  get loggedUser(): User | null {
    return this.authService.loggedUser;
  }

  get title$(): BehaviorSubject<string> {
    return this.helperService.titleChanged$;
  }

  get smallTextTitle$(): BehaviorSubject<string> {
    return this.helperService.smallTextTitle$;
  }

  get enableStartQuestionnaireButton(): boolean {
    return this.router.url.includes(this.routerLinkFactory.result()[0]);
  }

  onActivationCode() {
    this.modalService.open(EditLicenseComponent);
  }

  onLogout() {
    this.accountService.logout();
  }

  startQuestionnaire(): void {
    this.helperService.checkAdditionalInfo();
  }

  goBack() {
    this.location.back();
  }
}

export default HeaderComponent;
